import { Component } from '@angular/core';
import { soundpostReportOutputDeferredRevenueDetailEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output Deferred Revenue Details') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputdeferredrevenuedetail-form',
    templateUrl: './soundpostreportoutputdeferredrevenuedetail.form.component.html'
})
export class soundpostReportOutputDeferredRevenueDetailFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputDeferredRevenueDetailEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

